import React from 'react'

import RightDatesSection from '../../../ReusableSections/RightDatesSection'
import RightAllocationAndDelivery from '../../../ReusableSections/RightAllocationAndDelivery'
import RequestAssetsSection from '../../../ReusableSections/RequestAssetsSection'
import ActionsOrCommentsSection from '../../../ReusableSections/ActionsOrCommentsSection'

function OtherRightCreateSections({ formik }) {
  return (
    <>
      <RightDatesSection formik={formik} />
      <RightAllocationAndDelivery formik={formik} />
      <RequestAssetsSection formik={formik} />
      <ActionsOrCommentsSection formik={formik} />
    </>
  )
}

export default OtherRightCreateSections
